/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurvePoolNonPeggedAssetsLike,
  ICurvePoolNonPeggedAssetsLikeInterface,
} from "../ICurvePoolNonPeggedAssetsLike";

const _abi = [
  {
    inputs: [],
    name: "lp_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurvePoolNonPeggedAssetsLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurvePoolNonPeggedAssetsLikeInterface {
    return new utils.Interface(_abi) as ICurvePoolNonPeggedAssetsLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurvePoolNonPeggedAssetsLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurvePoolNonPeggedAssetsLike;
  }
}
